<template>
  <v-dialog v-model="dialog" max-width="560" :persistent="loading" scrollable>
    <v-card>
      <v-card-title>
        {{ audience.id ? "Editar" : "Novo" }} público-alvo
      </v-card-title>
      <v-card-text>
        <v-alert v-if="error" type="error" dense class="mb-3">
          {{ error }}
        </v-alert>
        <v-form v-model="valid" @submit.prevent>
          <v-text-field
            v-model="audience.name"
            label="Nome"
            outlined
            dense
            :disabled="loading"
            :rules="[(v) => !!v || 'Nome é obrigatório']"
          />
          <v-text-field
            v-model="audience.icon"
            label="Ícone (MDI)"
            outlined
            dense
            :disabled="loading"
            hint="Ex: mdi-account-group"
            persistent-hint
            :rules="[(v) => !!v || 'Ícone é obrigatório']"
          >
            <template v-slot:append>
              <v-icon>{{ audience.icon || "mdi-help-circle-outline" }}</v-icon>
            </template>
          </v-text-field>
          <v-textarea
            v-model="audience.description"
            label="Descrição"
            outlined
            dense
            rows="3"
            :disabled="loading"
          />
          <v-text-field
            v-model.number="audience.sortOrder"
            label="Ordem"
            type="number"
            outlined
            dense
            :disabled="loading"
          />
          <v-switch
            v-model="audience.active"
            label="Ativo"
            :disabled="loading"
            hide-details
            class="mt-0"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn color="primary" :loading="loading" :disabled="!valid" @click="save">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import featureAudiencesService from "@/services/ultimate/featureAudiences";
import { defaultFeatureAudience } from "@/utils/featureUtils";

export default {
  name: "FeatureAudienceDialog",
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      error: null,
      audience: defaultFeatureAudience(),
    };
  },
  methods: {
    open(audience = null) {
      this.audience = Object.assign(
        defaultFeatureAudience(),
        structuredClone(audience || {})
      );
      this.error = null;
      this.loading = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.audience = defaultFeatureAudience();
      this.error = null;
    },
    async save() {
      this.loading = true;
      this.error = null;
      try {
        if (this.audience.id) {
          await featureAudiencesService.update(this.audience);
        } else {
          await featureAudiencesService.create(this.audience);
        }
        this.$emit("success");
        this.close();
      } catch (error) {
        this.error = error.message || "Erro ao salvar público-alvo";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$root.$on("feature-audience-modal", this.open);
  },
  beforeDestroy() {
    this.$root.$off("feature-audience-modal", this.open);
  },
};
</script>
